import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles/LandingBlurb.css";
import Bottom from "../../static/landing/BlurbBottom.png";
import Top from "../../static/landing/BlurbTop.png";
import Down from "../../static/landing/Down.svg";

export default function LandingBlurb() {
    return (
        <div className="LandingBlurb">
            <section className="LandingBlurb-Top">
                <div className="LandingBlurb-Top-Text">
                    <h1>Instantly Grow Your Depop Following &amp; Boost Sales <span role="img" aria-label="sparkles">✨</span></h1>
                    <p>Salewave makes it easy to gain organic followers &amp; likes,
                     receive more reviews, auto-bump products, and more
                    </p>
                    <Link to="/pricing">Get Access Today!</Link>
                </div>
                <div className="LandingBlurb-Top-Img">
                    <div className="Bg-Top"></div>
                    <div className="Bg-Bottom"></div>
                    <img 
                    className="Img-Bottom"
                    src={Bottom} 
                    alt="Blurb 1" />
                    <img 
                    className="Img-Top" 
                    src={Top} 
                    alt="Blurb 2" />

                </div>
            </section>
            <div className="LandingBlurb-Bottom">
                <img src={Down} alt="Down arrow" />
                <p className="LandingBlurb-Bottom">The most powerful Depop automation tools in one web application</p>
            </div>

        </div>
    )
}